var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"env-fade"}},[(_vm.shouldShow)?_c('div',{staticClass:"env-notifier",attrs:{"role":"status","aria-live":"polite","title":`Environment: ${_vm.effectiveEnv}`}},[_vm._v(" Environment: "),_c('strong',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.effectiveEnv))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }